import React, { lazy, Suspense } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ReactJson from 'react-json-view';
import Loader from 'components/ui/loader';

const MonacoEditorLazy = lazy(() => import('@monaco-editor/react'));

const JSONViewer = ({ data, className, useMonaco }) => {
  if (useMonaco) {
    return (
      <div className="json-editor-wrapper">
        <Suspense fallback={<Loader />}>
          <MonacoEditorLazy
            height="100vh"
            language="json"
            theme="vs-dark"
            value={JSON.stringify(data, null, 2)}
            options={{ minimap: { enabled: false }, readOnly: true }}
          />
        </Suspense>
      </div>
    );
  }
  return (
    <div className={classNames('p-1', className)}>
      <ReactJson
        src={data}
        theme="monokai"
        displayDataTypes={false}
        displayObjectSize={false}
        enableClipboard={true}
        style={{ backgroundColor: 'transparent' }}
      />
    </div>
  );
};

JSONViewer.defaultProps = {
  className: '',
};

JSONViewer.propTypes = {
  data: PropTypes.object.isRequired,
  className: PropTypes.string,
};

export default JSONViewer;
